import React from 'react';

const ConsuTabla = ({ matdocentes = [], mat = '' }) => {
  const mostrarMateria = matdocentes.some(
    (ele) => (ele.materia && ele.materia.trim()) || ele.id_mat
  );

  const formatearActividad = (ele) => {
    const materia = ele?.materia?.trim?.() || '';
    const idActividad = ele?.id_mat ? String(ele.id_mat).trim() : '';

    if (!materia && !idActividad) return '—';
    if (!materia) return idActividad;
    if (!idActividad) return materia;

    return `${materia} (${idActividad})`;
  };

  const renderHorario = (valor) => {
    if (!valor || valor.trim().length < 2) {
      return <span className="hcd-td-empty">—</span>;
    }
    return <span className="hcd-horario-pill">{valor.trim()}</span>;
  };

  const renderVirtual = (texto) => {
    if (!texto || !texto.trim()) return <span className="hcd-td-empty">—</span>;
    const t = texto.trim();
    if (t.toLowerCase().startsWith('http')) {
      return (
        <a href={t} className="hcd-link" target="_blank" rel="noreferrer">
          {t}
        </a>
      );
    }
    return <span className="hcd-lugar-text">{t}</span>;
  };

  if (!matdocentes.length) return null;

  return (
    <>
      <div className="hcd-activity-header">
        <span className="hcd-activity-title">{mat}</span>
        <span className="hcd-count-badge">
          {matdocentes.length} registro{matdocentes.length > 1 ? 's' : ''}
        </span>
      </div>

      <div className="hcd-table-wrapper">
        <table className="hcd-table">
          <thead>
            <tr>
              <th>Docente</th>
              {mostrarMateria && <th>Actividad</th>}
              <th>Lunes</th>
              <th>Martes</th>
              <th>Miércoles</th>
              <th>Jueves</th>
              <th>Viernes</th>
              <th>Lugar presencial</th>
              <th>Consulta virtual</th>
              <th>Novedad</th>
            </tr>
          </thead>
          <tbody>
            {matdocentes.map((ele, ind) => (
              <tr key={ele.id_hora ?? `${ele.id_mat ?? 'sinmat'}-${ind}`}>
                <td className="hcd-td-docente">
                  {ele.apellido ? ele.apellido.trim() : '—'}
                </td>

                {mostrarMateria && (
                  <td className="hcd-td-materia">
                    {formatearActividad(ele)}
                  </td>
                )}

                <td>{renderHorario(ele.lunes)}</td>
                <td>{renderHorario(ele.martes)}</td>
                <td>{renderHorario(ele.miercoles)}</td>
                <td>{renderHorario(ele.jueves)}</td>
                <td>{renderHorario(ele.viernes)}</td>

                <td className="hcd-td-lugar">
                  {ele.lugar_c ? ele.lugar_c.trim() : '—'}
                </td>

                <td className="hcd-td-virtual">{renderVirtual(ele.lugar_v)}</td>

                <td className="hcd-td-novedad">
                  {ele.novedad && ele.novedad.trim() ? ele.novedad.trim() : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ConsuTabla;